// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Preact from "../bindings/Preact.js";
import * as JsxRuntime from "react/jsx-runtime";

let makeStyle = (function(s) { return s; });

function Ticket(props) {
  let __isRevealing = props.isRevealing;
  let storeName = props.storeName;
  let isRevealing = __isRevealing !== undefined ? __isRevealing : false;
  let match = React.useState(() => !isRevealing);
  let setRevealed = match[1];
  let revealed = match[0];
  React.useEffect(() => {
    if (!isRevealing) {
      return;
    }
    let timerId = setTimeout(() => setRevealed(param => true), 100);
    return () => {
      clearTimeout(timerId);
    };
  }, [isRevealing]);
  let style = makeStyle({
    opacity: revealed ? "1" : "0",
    transform: revealed ? "scale(1)" : "scale(0.9)",
    transition: "all 0.3s ease-out"
  });
  return JsxRuntime.jsxs("div", {
    children: [
      storeName !== undefined ? JsxRuntime.jsx("div", {
          children: storeName,
          className: "ticket-store-name",
          "data-testid": "ticket-store-name"
        }) : null,
      JsxRuntime.jsx("div", {
        children: `#` + props.number.toString(),
        className: "ticket-number-display",
        "data-testid": "ticket-number"
      }),
      JsxRuntime.jsx("div", {
        children: "Your Number",
        className: "ticket-your-number"
      })
    ],
    className: `paper-ticket ` + (
      revealed ? "revealed" : ""
    ),
    "data-testid": "ticket",
    style: style
  });
}

function expose() {
  Preact.setWindowProperty("Ticket", Ticket);
}

let make = Ticket;

export {
  makeStyle,
  make,
  expose,
}
/* react Not a pure module */
